/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAppSelector } from '../../../reducers';
import { SettingStorage } from '../../../services/SettingStorage';
import { useHistory } from 'react-router-dom';

const rememberDismiss = (key: string) => {
  const expireDate = new Date()
  expireDate.setMonth(expireDate.getMonth() + 1)
  SettingStorage.setItem(`dismiss-modal-${key}`, expireDate.getTime())
}
const isDismissed = (key: string)  => {
  const expireDate = SettingStorage.getItem(`dismiss-modal-${key}`)
  return expireDate && parseInt(expireDate) > (new Date()).getTime()
}

export const TriggeredModal = () => {
  const history = useHistory();
  const user = useAppSelector((state) => state.currentUser);
  if (!user.data.redirectConfig) {
    return null
  }

  const { title, content, redirectUrl, primary, secondary, key } = user.data.redirectConfig;
  if(isDismissed(key)) {
    return null
  }
  const handleRedirect = () => {
    if (!redirectUrl) {
      return
    }
    window.location.href = redirectUrl
  }
  const dismiss = () => {
    rememberDismiss(key)
    history.push('/marketplace')
  }

  return (
    <Modal isOpen backdrop='static'>
      <ModalHeader>
        { title }
      </ModalHeader>
      <ModalBody>
        { content }
      </ModalBody>
      <ModalFooter>
        { secondary ? <Button onClick={() => dismiss()}>{ secondary }</Button> : null}
        { primary ? <Button color='primary' onClick={() => handleRedirect()}>{ primary }</Button> : null}
      </ModalFooter>
    </Modal>
  );
};
